import { lazy } from 'react';

/**
 * bpmn-jsは本体だけで数百KBあり、Workspace一覧や設定画面では読み込む必要がない。
 * 図を開いたときにだけ取りに行くよう、遅延読み込みの入口をここに1つ置く。
 */
export const BpmnViewerLazy = lazy(async () => {
  const module = await import('./BpmnViewer');
  return { default: module.BpmnViewer };
});

export type { BpmnElementState, BpmnViewerProps } from './BpmnViewer';
